import {
  Checkbox,
  Paper,
  styled,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
  Typography,
  TextField,
  IconButton,
} from '@mui/material';
import React, { useEffect, useState, useRef } from 'react';
import { MoneyFormatv3 } from '../../library/MoneyFormat';
import { showWarningSnackbar } from '../snackBar/snakbar';
import theme from '../../styles/Themecolors';
import { MoneyInputv3 } from '../../features/Payment';
import { formatUnixTimestamp } from '../../library/dayJs.ts';
import SearchIcon from '@mui/icons-material/Search';
import Clear from '@mui/icons-material/Clear';
import { DateRangeRsuite, MoneyTextField } from '../../components';

const CustomTableContainer = styled(TableContainer)(({ theme }) => ({
  maxHeight: 'calc( * 48px)', // Assuming each row is 48px in height
  overflowY: 'auto',
  whiteSpace:'nowrap'
}));
const CustomTable = styled(Table)(({ theme }) => ({
  '& .MuiTableCell-root': {
    padding: 0,
    whiteSpace:'nowrap',
    textAlign: 'center',
  },
}));



const LinkingTable = ({ data = [], onChange, disabled, type }) => {
  console.log(data);
  const [showSearchRow, setShowSearchRow] = useState(false);
  const [searchFilters, setSearchFilters] = useState({
    invoiceDateFrom: '',
    invoiceDateTo: '',
    invoiceNumber: '',
    invoiceAmount: '',
    invoiceBalance: '',
  });

  // Debug logging for search filters
  console.log('Search filters:', searchFilters);

  // Get user preference data for date restrictions
  const dateRangeRef = useRef(null);

  // Filter data based on search filters
  const filteredData = data.filter((elem) => {
    const invoiceNumber = elem.ObjectAttribute?.toString().toLowerCase() || '';
    // Date range filtering
    const invoiceTimestamp = elem.invoicedate;
    let dateFromMatch = true;
    let dateToMatch = true;

    if (searchFilters.invoiceDateFrom) {
      console.log(
        'From timestamp:',
        searchFilters.invoiceDateFrom,
        'Invoice timestamp:',
        invoiceTimestamp,
        'Match:',
        invoiceTimestamp >= searchFilters.invoiceDateFrom
      );
      dateFromMatch = invoiceTimestamp >= searchFilters.invoiceDateFrom;
    }

    if (searchFilters.invoiceDateTo) {
      console.log(
        'To timestamp:',
        searchFilters.invoiceDateTo,
        'Invoice timestamp:',
        invoiceTimestamp,
        'Match:',
        invoiceTimestamp <= searchFilters.invoiceDateTo
      );
      dateToMatch = invoiceTimestamp <= searchFilters.invoiceDateTo;
    }

    // Money field filtering - parse formatted numbers like "1,000.00" to "1000.00"
    const rawInvoiceAmount = elem.Total?.toString() || '';
    const rawInvoiceBalance = (Number(elem.dueAmount) + (Number(elem.PreviousLinkedAmount) - Number(elem.LinkedAmount))).toString() || '';
    const searchAmount = searchFilters.invoiceAmount ? searchFilters.invoiceAmount.toString().replace(/,/g, '') : '';
    const searchBalance = searchFilters.invoiceBalance ? searchFilters.invoiceBalance.toString().replace(/,/g, '') : '';

    const amountMatch = !searchFilters.invoiceAmount || rawInvoiceAmount.includes(searchAmount);
    const balanceMatch = !searchFilters.invoiceBalance || rawInvoiceBalance.includes(searchBalance);

    return invoiceNumber.includes(searchFilters.invoiceNumber.toLowerCase()) && dateFromMatch && dateToMatch && amountMatch && balanceMatch;
  });

  const handleSearchFilterChange = (field, value) => {
    setSearchFilters((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <Box>
      <CustomTableContainer component={Paper} className="noTableCellBorder">
        <CustomTable stickyHeader>
          <TableHead>
            {/* Title row */}
            <TableRow
              sx={{
                '.MuiTableCell-root': {
                  padding: '8px 15px',
                },
                position: 'sticky',
                top: 0,
                zIndex: 10,
              }}
            >
              <TableCell colSpan={6}>
                <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    <span style={{ textTransform: 'capitalize' }}>{type}</span>s Linked to Invoice
                  </Typography>
                  <SearchIcon
                    sx={{
                      color: theme.palette.grey[600],
                      cursor: 'pointer',
                      '&:hover': { color: theme.palette.primary.main },
                    }}
                    onClick={() => setShowSearchRow(!showSearchRow)}
                  />
                </Box>
              </TableCell>
            </TableRow>

            {/* Header row */}
            <TableRow
              sx={{
                '.MuiTableCell-root': {
                  backgroundColor: `${theme.palette.background.tablebg} !important`,
                  paddingX:"5px"
                },
                backgroundColor: 'background.tablebg',
                fontSize: '14px',
                position: 'sticky',
                top: 0,
                zIndex: 10,
              }}
            >
              <TableCell></TableCell>
              <TableCell className="text-start">Invoice Date</TableCell>
              <TableCell className="text-start">Invoice Number</TableCell>
              <TableCell className="text-end">Invoice Amount</TableCell>
              <TableCell className="text-end">Invoice Balance</TableCell>
              <TableCell sx={{ padding: '5px !important', textAlign: 'right', minWidth: 200 }}>Amount Applied to Invoice</TableCell>
            </TableRow>

            {/* Search row */}
            {showSearchRow && (
              <TableRow
                sx={{
                  '.MuiTableCell-root': {
                    backgroundColor: `${theme.palette.grey[50]} !important`,
                    padding: '8px 15px',
                  },
                  position: 'sticky',
                  top: showSearchRow ? '48px' : 0,
                  zIndex: 9,
                  backgroundColor: `${theme.palette.grey[50]} !important`,
                }}
              >
                <TableCell></TableCell>
                <TableCell>
                  <Paper
                    id="invoiceDateSearch"
                    sx={{
                      p: '2px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <DateRangeRsuite
                      ref={dateRangeRef}
                      className="hide-input-outline hide-input-border"
                      value={[
                        searchFilters.invoiceDateFrom ? searchFilters.invoiceDateFrom : null,
                        searchFilters.invoiceDateTo ? searchFilters.invoiceDateTo : null,
                      ]}
                      onChange={(e) => {
                        setSearchFilters((prev) => ({
                          ...prev,
                          invoiceDateFrom: e.from ? e.from : '',
                          invoiceDateTo: e.to ? e.to : '',
                        }));
                      }}
                      restrictToFinancialYear
                    />
                  </Paper>
                </TableCell>
                <TableCell>
                  <Paper
                    id="invoiceNumberSearch"
                    sx={{
                      p: '2px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <TextField
                      placeholder="Search"
                      value={searchFilters.invoiceNumber}
                      onChange={(e) => handleSearchFilterChange('invoiceNumber', e.target.value)}
                      size="small"
                      sx={{ width: '100%' }}
                    />
                    <IconButton type="button" sx={{ p: '0px' }}>
                      {searchFilters.invoiceNumber !== '' ? (
                        <Clear
                          fontSize="small"
                          onClick={() => {
                            setSearchFilters((prev) => ({
                              ...prev,
                              invoiceNumber: '',
                            }));
                          }}
                        />
                      ) : (
                        <SearchIcon fontSize="small" />
                      )}
                    </IconButton>
                  </Paper>
                </TableCell>
                <TableCell>
                  <Paper
                    id="invoiceAmountSearch"
                    sx={{
                      p: '2px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <MoneyTextField
                      value={searchFilters.invoiceAmount}
                      onChange={(e) => handleSearchFilterChange('invoiceAmount', e)}
                      size="small"
                      sx={{ width: '100%' }}
                    />
                    <IconButton type="button" sx={{ p: '0px' }}>
                      {searchFilters.invoiceAmount !== '' ? (
                        <Clear
                          fontSize="small"
                          onClick={() => {
                            setSearchFilters((prev) => ({
                              ...prev,
                              invoiceAmount: '',
                            }));
                          }}
                        />
                      ) : (
                        <SearchIcon fontSize="small" />
                      )}
                    </IconButton>
                  </Paper>
                </TableCell>
                <TableCell>
                  <Paper
                    id="invoiceBalanceSearch"
                    sx={{
                      p: '2px 4px',
                      display: 'flex',
                      alignItems: 'center',
                      width: '100%',
                    }}
                  >
                    <MoneyTextField
                      value={searchFilters.invoiceBalance}
                      onChange={(e) => handleSearchFilterChange('invoiceBalance', e)}
                      size="small"
                      sx={{ width: '100%' }}
                    />
                    <IconButton type="button" sx={{ p: '0px' }}>
                      {searchFilters.invoiceBalance !== '' ? (
                        <Clear
                          fontSize="small"
                          onClick={() => {
                            setSearchFilters((prev) => ({
                              ...prev,
                              invoiceBalance: '',
                            }));
                          }}
                        />
                      ) : (
                        <SearchIcon fontSize="small" />
                      )}
                    </IconButton>
                  </Paper>
                </TableCell>
                <TableCell></TableCell>
              </TableRow>
            )}
          </TableHead>
          {filteredData.map((elem, index) => {
            // Find the original index in the unfiltered data
            const originalIndex = data.findIndex((item) => item === elem);
            return (
              <LinkingRow
                key={originalIndex}
                data={elem}
                index={originalIndex}
                disabled={disabled}
                onChange={(value) => {
                  return onChange(value, originalIndex);
                }}
              ></LinkingRow>
            );
          })}
        </CustomTable>
      </CustomTableContainer>
    </Box>
  );
};

const LinkingRow = ({ data, onChange, disabled }) => {
  const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
  const [checked, setchecked] = useState(false);
  useEffect(() => {
    console.log(data.LinkedAmount);
    if (data.LinkedAmount > 0) {
      setchecked(true);
    } else {
      setchecked(false);
    }
    console.log(data.LinkedAmount);
    return () => {};
  }, [data.LinkedAmount]);

  return (
    <TableRow
      className="TableCellBorder"
      sx={{
        '.MuiTableCell-root': {
          backgroundColor: 'transparent !important',
          padding: '8px 15px',
        },
      }}
    >
      <TableCell>
        <Checkbox
          disabled={disabled}
          checked={checked}
          onChange={(e) => {
            console.log(e.target.checked);
            let res = onChange(e.target.checked);
            console.log(res);
            if (res == false) {
              showWarningSnackbar('No amount left');
            } else {
              setchecked(e.target.checked);
            }
          }}
          {...label}
        />
      </TableCell>
      <TableCell>{formatUnixTimestamp(data.invoicedate)}</TableCell>
      <TableCell>{data.ObjectAttribute}</TableCell>
      <TableCell className="text-end">{MoneyFormatv3(data.Total)}</TableCell>
      <TableCell className="text-end">
        {/* {`${data.dueAmount} + (${data.PreviousLinkedAmount} - ${data.LinkedAmount})`} */}
        {MoneyFormatv3(Number(data.dueAmount) + (Number(data.PreviousLinkedAmount) - Number(data.LinkedAmount)))}
      </TableCell>
      <TableCell>
        <MoneyInputv3
          disabled={disabled}
          state={data.LinkedAmount}
          onChange={(value) => {
            if (value >= 0) {
              onChange(value);
            }
          }}
          // onBlur={(value) => { onChange(Number(value))}}
        ></MoneyInputv3>
      </TableCell>
    </TableRow>
  );
};

export default LinkingTable;
